<template lang='pug'>
  div
    b-modal(ref="my-modal" hide-footer title="Event-Info")
      h3 {{event.title}}
      br
      strong Von
      p {{event.start_show}}
      strong Bis
      p {{event.end_show}}
      .row
        .col
          strong Zeit
          p {{toTimeString(event.minutes * 60)}} ({{toNumber(event.minutes / 60)}} h)       
        .col
          strong Betrag
          p {{toCurrency(event.minutes / 60 * event.rate)}}           
      br

      a.btn.btn-primary(:href="'/time_items/'+event.id+'/edit'") Event bearbeiten
    full-calendar(ref="calendar" :events="events" :config='fullCalendarConfig')
</template>

<script>
// import Api from 'timetracking/api'

/* global $ */
/* eslint no-underscore-dangle: 0 */
/* eslint arrow-body-style: 0 */

const _toNumber = (number) => {
  return Intl.NumberFormat('de-DE', { minimumSignificantDigits: 3, maximumSignificantDigits: 3 }).format(number)
}

const _toCurrency = (amount) => {
  return Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(amount)
}

const _toTimeString = (timeSeconds) =>{
  let totalSeconds = Math.abs(timeSeconds)
  let hours = Math.floor(totalSeconds / 3600);
  totalSeconds %= 3600;
  let minutes = Math.floor(totalSeconds / 60);
  let seconds = totalSeconds % 60;
  let prefix = ""
  minutes = String(Math.floor(minutes)).padStart(2, "0");
  hours = String(Math.floor(hours)).padStart(2, "0");
  seconds = String(Math.floor(seconds)).padStart(2, "0");
  if (timeSeconds < 0 && (minutes != "00" || hours != "00")){
    prefix = "-"
  }
  return prefix + hours + "h " + minutes + "m"
}

const _hourSumFor = (events) => {
  const sum = events.map((e) => {
    if (!e) {
      return 0;
    } else if (e.event._allDay) {
      return 0;
    } else {
      return e.eventDurationMS / 1000 / 3600;
    }
  }).reduce((a, s) => a + s, 0)
  return sum;
}

const _addHourIndicator = (element, hours, target) => {
  let small = element.find('small')
  if (small.length === 0) {
    small = $("<small class='hour-indicator'></small>").appendTo(element)
  }
  small.html(_toNumber(hours) + "h").attr('title', _toTimeString(hours* 3600))
  if (hours < target * 0.8 || hours > target) {
    small.addClass('text-danger').removeClass('text-success')
  } else {
    small.addClass('text-success').removeClass('text-danger')
  }
}
export default {
  props: ["events"],
  components: { Modal },
  data() {
    return {
      event: {},
    }
  },
  mounted() {
    setTimeout(() => {
      this.$refs.calendar.$emit('reload-events')
    }, 500)
  },
  watch: {
    events() {
      this.$refs.calendar.$emit('reload-events')
      this.$refs.calendar.$emit('refetch-events')
    }
  },
  computed: {
    fullCalendarConfig() {
      const that = this
      return {
        timezone: 'Europe/Berlin',
        weekNumbers: true,
        locale: 'de',
        selectable: false,
        eventOverlap: true,
        eventDurationEditable: false,
        // eventLimit: true,
        firstDay: 1,
        eventRender(event, element, _view) {
          const hoursRounded = Math.round(event.minutes / 0.6) / 100;
          element.find('.fc-time').html(`${hoursRounded}h`)

          if(event.rendering == "background") {
            element.html(`<div class="info-event"><small>${event.title}</small></div>`)
          }
          return element;
        },
        eventClick(event){
          if (!event.id) {
            return;
          }
          that.event = event
          that.$refs['my-modal'].show()
        },
        eventDrop(event, delta, revertFunc) {
          if (event.start.day() === 0) {
            return revertFunc();
          }
          if (!event.id) {
            return revertFunc();
          }

          let data = delta._data
          data.id = event.id
          fetch("/update_entries", {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
              'Content-Type': 'application/json'
              // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data) // body data type must match "Content-Type" header
          });
        },
        eventAfterAllRender(view) {
          if (view.type !== "month") return;
          view.dayGrid.rowStructs.forEach((row) => {
            const sum = _hourSumFor(row.segs)
            const table = $(view.dayGrid.rowEls[row.row]).find('.fc-content-skeleton')
            const weekNumberEl = table.find('td.fc-week-number').first()
            const daysInWeek = table.find('.fc-past,.fc-today').not('.fc-sun, .fc-sat').length
            const workTarget = 8 * daysInWeek;
            _addHourIndicator(weekNumberEl, sum, workTarget)
            table.find('.fc-day-top').each((i, el) => {
              const daySum = _hourSumFor(row.segMatrix.map(e => e[i]))
              _addHourIndicator($(el), daySum, 8)
            })
          })
        },
        defaultView: 'month'
      }
    }
  },
  methods: {
    toTimeString(x){
      return _toTimeString(x)
    },
    toNumber(x){
      return _toNumber(x)
    },
    toCurrency(x){
      return _toCurrency(x)
    },
    refresh() {
      const container = $(this.$refs.calendar.$el)
      const view = container.fullCalendar('getView')
      view.unrenderDates();
      view.renderDates();
      container.fullCalendar('rerenderEvents');
    },
  }
}

</script>

<style>
.info-event{
  color: #3C4858;
  margin-left: 5px;
  margin-top: 15px;
}
.fc-bgevent {
  opacity: 1!important;
}
.fc-basic-view .fc-body .fc-row {
  min-height: 6em !important;
}
.fc-week-number .hour-indicator{
  -webkit-transform: rotate(270deg);
  position: absolute;
  top: 40px;
  left: -2px;
}
strong{
  font-weight: 800;
}
.fc-day-top .hour-indicator {
  margin-left: 5px;
  font-size: 12px;
}
.fc-title {
  font-size: 11px;
}
.fc-time {
  font-size: 10px;
  font-weight: bold;
}
.fc-scroller {
  height: auto !important;
  overflow: hidden !important;
}

.fc-event.fc-draggable {
  box-shadow: 1px 1px 2px #999;
}
.modal-backdrop{
opacity: 0.5;
}
</style>
